module.exports = __webpack_public_path__ + "img/dsci0158.86d961c0.jpg";